import { createTheme } from "@mui/material/styles";
import treffas from "./treffas";

const { colors, typography, breakpoints } = treffas;

const theme = createTheme({
  palette: {
    primary: {
      main: colors.brand.navy,
      light: colors.brand.primary,
      dark: colors.brand.navyHover,
      contrastText: colors.text.inverse,
    },
    secondary: {
      main: colors.brand.primary,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
    },
    success: {
      main: colors.semantic.success,
    },
    error: {
      main: colors.semantic.error,
    },
    background: {
      default: colors.background.default,
      paper: colors.background.default,
    },
    divider: colors.border.default,
  },
  typography: {
    fontFamily: typography.fontFamily.body,
    allVariants: {
      color: colors.text.primary,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: typography.fontWeight.medium,
          textTransform: "inherit",
          fontFamily: typography.fontFamily.heading,
          "&:focus": {
            outline: "none",
          },
          "&:focus-visible": {
            boxShadow: treffas.shadow.focus,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.brand.primary,
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: typography.fontFamily.heading,
          textTransform: "none",
          fontWeight: typography.fontWeight.regular,
          "&.Mui-selected": {
            color: colors.text.tabActive,
            borderBottom: `2px solid ${colors.brand.primary}`,
          },
          "&:not(.Mui-selected)": {
            color: colors.text.muted,
            borderBottom: "2px solid transparent",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: "none",
        },
      },
    },
  },
  breakpoints: {
    values: breakpoints,
  },
  treffas,
});

export default theme;
